var map = {
	"./author-404": 8,
	"./author-404.jpg": 8,
	"./blau-simple": 9,
	"./blau-simple.svg": 9,
	"./blick-ins-buch-label": 10,
	"./blick-ins-buch-label.svg": 10,
	"./boxes/aktien": 11,
	"./boxes/aktien.jpg": 11,
	"./boxes/buecherstapel": 12,
	"./boxes/buecherstapel.jpg": 12,
	"./favicon/android-chrome-192x192": 13,
	"./favicon/android-chrome-192x192.png": 13,
	"./favicon/android-chrome-256x256": 14,
	"./favicon/android-chrome-256x256.png": 14,
	"./favicon/apple-touch-icon": 15,
	"./favicon/apple-touch-icon.png": 15,
	"./favicon/favicon-16x16": 16,
	"./favicon/favicon-16x16.png": 16,
	"./favicon/favicon-32x32": 17,
	"./favicon/favicon-32x32.png": 17,
	"./favicon/favicon.ico": 80,
	"./favicon/mstile-150x150": 18,
	"./favicon/mstile-150x150.png": 18,
	"./favicon/rotpunkt_favicon": 19,
	"./favicon/rotpunkt_favicon.png": 19,
	"./favicon/safari-pinned-tab": 20,
	"./favicon/safari-pinned-tab.svg": 20,
	"./logos/editionblau-logo": 21,
	"./logos/editionblau-logo.svg": 21,
	"./logos/rotpunkt-logo": 5,
	"./logos/rotpunkt-logo-og": 22,
	"./logos/rotpunkt-logo-og.jpg": 22,
	"./logos/rotpunkt-logo.jpg": 81,
	"./logos/rotpunkt-logo.svg": 5,
	"./logos/rotpunkt-setzen": 23,
	"./logos/rotpunkt-setzen.png": 23,
	"./sessel": 24,
	"./sessel.png": 24,
	"./title-404": 25,
	"./title-404.jpg": 25,
	"./wanderweb/header-wanderweb": 26,
	"./wanderweb/header-wanderweb-mobile": 27,
	"./wanderweb/header-wanderweb-mobile.jpg": 27,
	"./wanderweb/header-wanderweb.jpg": 26,
	"./wanderweb/wanderweb": 28,
	"./wanderweb/wanderweb-circle": 29,
	"./wanderweb/wanderweb-circle.png": 29,
	"./wanderweb/wanderweb.jpg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;